export default "<app-task-list-view></app-task-list-view>\r\n";